export default "__VITE_ASSET__D7ULd$6X__"